"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var EditorialOfficeModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorialOfficeModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_slicksort_1 = require("vue-slicksort");
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const form_1 = require("../_abstract/form");
const _contracts_1 = require("../_contracts");
const form_2 = require("../_components/form");
/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 * @author Adrian Gajos <adrian.gajos@movecloser.pl>
 */
let EditorialOfficeModuleForm = EditorialOfficeModuleForm_1 = class EditorialOfficeModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.authors = {};
        this.icons = backoffice_1.DashmixIconName;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = EditorialOfficeModuleForm_1.getInitialContent();
    }
    /**
     * Function to check if header exist
     *
     * @return boolean
     */
    get hasHeader() {
        return this._content.header !== null;
    }
    /**
     * Function to set header according to hasHeader value
     */
    set hasHeader(value) {
        if (!value) {
            this._content.header = null;
            return;
        }
        this._content.header = {
            small: null,
            intro: {
                isBold: false,
                text: null
            },
            large: null
        };
    }
    /**
     * Vue lifecycle hook.
     */
    mounted() {
        this.$nextTick(() => {
            for (const author of this._content.authors) {
                this.describeAuthors(author);
            }
        });
    }
    /**
     * Function to delete author
     *
     * @param index of author to delete
     */
    deleteAuthor(index) {
        const authorsCopy = [...this._content.authors];
        authorsCopy.splice(index, 1);
        this._content.authors = authorsCopy;
    }
    /**
     * Function to open picker to select author
     */
    findAuthorSource() {
        this.pickRelated(services_1.Picker.Author, this.setAuthor);
    }
    /**
     * Get author full name
     *
     * @param id
     */
    getAuthorName(id) {
        const author = this.authors[id];
        if (!author) {
            return 'Nie znaleziona autora o id ' + id;
        }
        return author.firstName + ' ' + author.lastName;
    }
    /**
     * Function to check if author has avatar
     */
    hasAvatar(author) {
        const authorData = this.authors[author.value];
        if (!authorData) {
            return false;
        }
        return !(!authorData.avatar || typeof authorData.avatar.value === 'undefined');
    }
    /**
     * Get author avatar Thumbnail from description object
     *
     * @param author
     */
    imageThumbnail(author) {
        if (!this.hasAvatar(author)) {
            return '';
        }
        return this.description(this.authors[author.value].avatar);
    }
    /**
     * Function to get author object from relatedServices
     *
     * @param author as Related object
     */
    describeAuthors(author) {
        this.relatedService.describe(author).then(related => {
            this.authors = { ...this.authors, [author.value]: related };
            if (related.avatar && typeof related.avatar.value !== 'undefined') {
                this.describe(related.avatar, 'url');
            }
        }).catch((e) => {
            console.warn(e);
        });
    }
    /**
     * Function to add author selected from picker
     *
     * @param related - selected related object
     */
    setAuthor(related) {
        this._content.authors = [...this._content.authors, related];
        this.describeAuthors(related);
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.EditorialOffice,
            size: {
                colSpan: 6,
                isResizable: false,
                maxColSpan: 6,
                maxRowSpan: 1,
                minColSpan: 1,
                minRowSpan: 1,
                rowSpan: 1
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            background: null,
            header: null,
            authors: []
        };
    }
};
EditorialOfficeModuleForm = EditorialOfficeModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'EditorialOfficeModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixAvatar: backoffice_1.DashmixAvatar,
            ModuleHeaderForm: form_2.ModuleHeaderForm,
            FormErrors: form_2.FormErrors,
            SlickList: vue_slicksort_1.SlickList,
            SlickItem: vue_slicksort_1.SlickItem
        },
        template: `
    <div>
      <!-- Header -->
      <DashmixCheck class="pb-2" :label="$t('forms.shared.hasHeader')" name="hasHeader"
                    :model.sync="hasHeader" />

      <ModuleHeaderForm v-if="hasHeader" :data.sync="_content.header" />
      <!-- Header| END -->

      <!-- Background -->
      <div class="form-group">
        <label for="background" class="d-block">{{ $t('forms.shared.background.label') }}</label>
        <DashmixInput type="color" :model.sync="_content.background" name="background"
                      :placeholder="$t('forms.shared.background.placeholder')" />
      </div>
      <!-- Background | END -->

      <!-- Authors -->
      <div class="form-group mb-4">
        <label for="list_value" class="d-block">{{ $t('forms.editorialOffice.authors') }}</label>

        <SlickList :value="_content.authors" v-model="_content.authors"
                   axis="y" lockAxis="y" tag="ol" :distance="50"
                   class="draggable__list p-0 list-unstyled" appendTo=".draggable__list"
                   helperClass="shadow is-grabbing">

          <!-- Single Author -->
          <SlickItem v-for="(author, index) in _content.authors" :key="author.value"
                     :index="index" tag="li" class="bg-light py-3 row mx-0 mb-3 draggable__list__icon">
            <div class="col-11 d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <DashmixAvatar size="x-large" :source="imageThumbnail(author)" :person="getAuthorName(author.value)" />
                <p class="pl-3 mb-0">{{ getAuthorName(author.value) }}</p>
              </div>
            </div>

            <div class="col-1 d-flex align-items-center p-0">
              <DashmixButton variant="icon" :icon="icons.TrashSolid" theme="danger"
                             @click="() => deleteAuthor(index)" />
            </div>
          </SlickItem>
          <!-- Single Author | END -->

        </SlickList>
        <!-- Authors | END -->

        <DashmixButton :icon="icons.PlusSolid" variant="icon" :label="$t('forms.editorialOffice.addNew')"
                       @click="findAuthorSource" />
      </div>

      <!-- Form errors -->
      <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
    </div>`
    })
], EditorialOfficeModuleForm);
exports.EditorialOfficeModuleForm = EditorialOfficeModuleForm;
//# sourceMappingURL=EditorialOffice.form.js.map